<div class="xi-modal__container upload-info__container" *transloco="let t; read: 'upload-info'">
  <h2 class="xi-modal__title">
    <ng-container *appMiddleEllipsize="t('upload') + ' ' + upload.file_name"></ng-container>
  </h2>

  @if (!collection.isSocial) {
    <div class="upload-info__content">
      <xi-horizontal-tab-bar
        [data]="uploadInfoTabs"
        [tabSpacing]="25"
        color="CX"
        [(activeTabId)]="activeTab"
      ></xi-horizontal-tab-bar>
      <div
        [ngClass]="
          activeTab === 'details'
            ? 'upload-info__tab-content--display'
            : 'upload-info__tab-content--hide'
        "
        class="upload-info__list-container"
      >
        <div class="upload-info__list">
          <div class="upload-info__list-item">
            <xi-icon icon="folder" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('collection') }}</h4>
              <p>{{ collection.displayName }}</p>
              <p>{{ collection.collectionName }}</p>
            </div>
          </div>
          <div class="upload-info__list-item">
            <xi-icon icon="attach" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('file-name') }}</h4>
              <p>{{ upload.file_name }}</p>
            </div>
          </div>
          <div class="upload-info__list-item">
            <xi-icon icon="info" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('details') }}</h4>
              <p>
                {{ upload.size_bytes | bytes }} {{ t('size') }}
                <br />
                {{ upload.document_count }} {{ t('documents') }}
                <br />
                {{ t('id') }} {{ upload.id }}
              </p>
            </div>
          </div>
          <div class="upload-info__list-item">
            <xi-icon icon="calendar" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('uploaded') }}</h4>
              <p>{{ upload.created_at | lexDate }}</p>
            </div>
          </div>
          <div class="upload-info__list-item">
            <xi-icon icon="indeterminate" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('state') }}</h4>
              @if (upload.state === 'DELETED') {
                <p>{{ t('deleted') }}</p>
              }
              @if (upload.state === 'CANCELLED') {
                <p>{{ t('cancelled') }}</p>
              }
              @if (upload.state === 'NEW') {
                <p>{{ t('new') }}</p>
              }
              @if (upload.state === 'INSPECTED') {
                <p>
                  {{ t('waiting-for-column-mapping') }}
                </p>
              }
              @if (upload.state === 'MAPPED') {
                <p>{{ t('waiting-for-processing') }}</p>
              }
              @if (upload.state === 'STARTED') {
                <p>{{ t('in-progress') }} ({{ upload.result.submitted }})</p>
              }
              @if (upload.state === 'COMPLETE') {
                <p>{{ t('finished') }} ({{ upload.result.submitted }})</p>
              }
            </div>
          </div>
          @if (upload.message) {
            <div class="upload-info__list-item">
              <xi-icon icon="notepad" iconSize="large"></xi-icon>
              <div class="upload-info__list-item-text">
                <h4>{{ t('message') }}</h4>
                <p>{{ upload.message }}</p>
              </div>
            </div>
          }
        </div>
      </div>
      <div
        [ngClass]="
          activeTab === 'results'
            ? 'upload-info__tab-content--display'
            : 'upload-info__tab-content--hide'
        "
        class="upload-info__list-container"
      >
        <div class="upload-info__list">
          <div class="upload-info__list-item">
            <xi-icon icon="reply" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('submitted') }}</h4>
              <p>{{ upload.document_count }}</p>
            </div>
          </div>
          <div class="upload-info__list-item">
            <xi-icon icon="circle_check" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('accepted') }}</h4>
              <p>{{ upload.result.updated + upload.result.added }}</p>
            </div>
          </div>
          <div class="upload-info__list-item">
            <xi-icon icon="copy" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('duplicate') }}</h4>
              <p>{{ upload.result.updated - collection.documentCount }}</p>
            </div>
          </div>
          <div class="upload-info__list-item">
            <xi-icon icon="document_alert" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('errors') }}</h4>
              <p>{{ upload.result.errors }}</p>
            </div>
          </div>
          @if (upload.result.error_types.length > 0) {
            <table mat-table [dataSource]="upload.result.error_types" class="results-table">
              <ng-container matColumnDef="no_rows">
                <th mat-header-cell *matHeaderCellDef>{{ t('number-of-rows') }}</th>
                <td mat-cell *matCellDef="let element">{{ element.count }}</td>
              </ng-container>
              <ng-container matColumnDef="first_row">
                <th mat-header-cell *matHeaderCellDef>{{ t('first-row') }}</th>
                <td mat-cell *matCellDef="let element">{{ element.first_row }}</td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>{{ t('type') }}</th>
                <td mat-cell *matCellDef="let element">
                  {{ getErrorTypeDisplay(element.error_type) }}
                </td>
              </ng-container>
              <ng-container matColumnDef="details">
                <th mat-header-cell *matHeaderCellDef>{{ t('details') }}</th>
                <td mat-cell *matCellDef="let element" class="upload-info__error-text">
                  {{ element.error_data }}
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsResults; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsResults"></tr>
            </table>
          }
        </div>
      </div>
      <div
        [ngClass]="
          activeTab === 'columnMapping'
            ? 'upload-info__tab-content--display'
            : 'upload-info__tab-content--hide'
        "
        class="upload-info__list-container"
      >
        <div class="upload-info__list">
          <table mat-table [dataSource]="uploadColumns" class="column-mapping__table">
            <ng-container matColumnDef="column_name">
              <th mat-header-cell *matHeaderCellDef>{{ t('column-name') }}</th>
              <td mat-cell *matCellDef="let element">{{ element.column_name }}</td>
            </ng-container>
            <ng-container matColumnDef="field_name">
              <th mat-header-cell *matHeaderCellDef>{{ t('field-name') }}</th>
              <td mat-cell *matCellDef="let element">
                <span [class.ellipsis-loader]="!fieldMap.has(element.field_name)">
                  {{ getFieldLabel(element.field_name) }}
                </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="field_type">
              <th mat-header-cell *matHeaderCellDef>{{ t('type') }}</th>
              <td mat-cell *matCellDef="let element">
                <span [class.ellipsis-loader]="!fieldMap.has(element.field_name)">
                  {{ getFieldType(element.field_name) }}
                </span>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsMapping; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsMapping"></tr>
          </table>
          @if (uploadColumns?.length === 0) {
            <div class="column-mapping--empty">
              {{ t('no-column-mapping') }}
            </div>
          }
        </div>
      </div>
    </div>
  }
  @if (collection.isSocial) {
    <div class="upload-info__content">
      <div class="upload-info__list-container">
        <div class="upload-info__list">
          <div class="upload-info__list-item">
            <xi-icon icon="folder" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('collection') }}</h4>
              <p>{{ collection.displayName }}</p>
              <p>{{ collection.collectionName }}</p>
            </div>
          </div>
          <div class="upload-info__list-item">
            <xi-icon icon="attach" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('file-name') }}</h4>
              <p>{{ upload.file_name }}</p>
            </div>
          </div>
          <div class="upload-info__list-item">
            <xi-icon icon="info" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('details') }}</h4>
              <p>
                {{ upload.size_bytes | bytes }} {{ t('size') }}
                <br />
                {{ upload.document_count }} {{ t('documents') }}
                <br />
                {{ t('id') }} {{ upload.id }}
              </p>
            </div>
          </div>
          <div class="upload-info__list-item">
            <xi-icon icon="calendar" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('analyzed-period') }}</h4>
              <p>{{ upload['period_start'] | lexDate }} - {{ upload['period_end'] | lexDate }}</p>
            </div>
          </div>
          <div class="upload-info__list-item">
            <xi-icon icon="pie_chart" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('total-impressions') }}</h4>
              <p>{{ upload['total_impressions'] }}</p>
            </div>
          </div>
          <div class="upload-info__list-item">
            <xi-icon icon="users" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('total-authors') }}</h4>
              <p>{{ upload['total_authors'] }}</p>
            </div>
          </div>
          <div class="upload-info__list-item">
            <xi-icon icon="translation" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('language') }}</h4>
              <p>{{ upload['language'] }}</p>
            </div>
          </div>
          <div class="upload-info__list-item">
            <xi-icon icon="database" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('source') }}</h4>
              @for (source of upload['sources']; track source) {
                <p>{{ source }}</p>
              }
            </div>
          </div>
          <div class="upload-info__list-item">
            <xi-icon icon="app_exec_reporting" iconSize="large"></xi-icon>
            <div class="upload-info__list-item-text">
              <h4>{{ t('query') }}</h4>
              @for (query of upload['queries']; track query) {
                <p>{{ query }}</p>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
